const kpiValueExtractor = (summaryReturnPercentDenominator, kpi) => {
    return (groupingRow) => {
        switch (kpi) {
            case "absoluteReturnPercent":
            case "relativeReturnPercent":
                const maybeReturnPercents = groupingRow[summaryReturnPercentDenominator];
                return maybeReturnPercents ? maybeReturnPercents[kpi] : null;
            case "absolutePnl":
            case "relativePnl":
            case "absoluteHitRate":
            case "relativeHitRate":
            case "customScore":
            default:
                return groupingRow[kpi];
        }
    };
};

export class ValueChooser {
    constructor({summaryReturnPercentDenominator, shareBased}) {
        this.returnPercentStrategy = shareBased ? summaryReturnPercentDenominator : "pricesOnly";
    }

    valueFor({valueName, groupingRow}) {
        return kpiValueExtractor(this.returnPercentStrategy, valueName)(groupingRow);
    }
}

export default class KpiChooser {
    constructor({summaryReturnPercentDenominator, kpi, shareBased}) {
        this.returnPercentStrategy = shareBased ? summaryReturnPercentDenominator : "pricesOnly";
        this.kpi = kpi;
        this.shareBased = shareBased;
    }

    selectedKpi({isAdditionalGrouping}) {
        let returnPercentStrategy = this.returnPercentStrategy;
        let valueName = this.kpi;

        if (isAdditionalGrouping) {
            if (returnPercentStrategy === "allocatedInvestment") {
                if (this.kpi === "absoluteReturnPercent") {
                    valueName = "absolutePnl";
                }
                if (this.kpi === "relativeReturnPercent") {
                    valueName = "relativePnl";
                }
            }

            if (this.kpi === "customScore") {
                valueName = "relativeReturnPercent"
            }
        }

        return {
            name: valueName,
            matchesConfiguredKpi: valueName === this.kpi,
            valueFor: kpiValueExtractor(this.returnPercentStrategy, valueName)
        };
    }

    canShow(valueName, groupingName) {
        const isRankingGrouping = ['author', 'author-company'].includes(groupingName);

        function showReturnPercents(returnPercentStrategy) {
            return ["averageInvestment", "pricesOnly"].includes(returnPercentStrategy) || isRankingGrouping;
        }
        function showCustomScore(kpi) {
            return kpi === "customScore" && isRankingGrouping;
        }

        switch (valueName) {
            case "absolutePnl":
            case "relativePnl":
                return this.shareBased;
            case "absoluteReturnPercent":
            case "relativeReturnPercent":
                return showReturnPercents(this.returnPercentStrategy);
            case "absoluteHitRate":
            case "relativeHitRate":
                return true;
            case "customScore":
                return showCustomScore(this.kpi)
        }
    }
};